var map = {
	"./books.jpg": 707,
	"./bulb.jpg": 951,
	"./bulb2.jpg": 115,
	"./laptop-2.jpg": 289,
	"./magazine.jpg": 995,
	"./magnifyer.jpg": 682,
	"./newspaper.jpg": 246,
	"./team.jpg": 630,
	"./todo.jpg": 855,
	"./trello.jpg": 456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 797;